// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Invoice_wrapper__XDJvG","anchor":"Invoice_anchor__uZvFo","icon":"Invoice_icon___SnoL"};